/* app/controls/control.gallery-rotator */
import 'magnific-popup';

let $galleryRotators;
var module = {
	init: function($elms) {
		$galleryRotators = $elms;

		for (let i = 0; i < $galleryRotators.length; i++) {
			module._initLightbox($galleryRotators.eq(i));
		}
	},

	_initLightbox: function ($galleryRotator) {
		$galleryRotator.magnificPopup({
			delegate: '.js-gallery-rotator__image',
			type: 'image',
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
			}
		});
	}
};

export { module as GalleryRotator };
